import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { Copyright, GitBookLink } from '@/constants/manifast'

import { Dividing } from '../common/Structure'
import { SilkscreenText } from '../common/Text'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  return (
    <footer className="flex flex-col items-center justify-center gap-1 py-5 text-xs xl:flex-row xl:gap-6">
      <SilkscreenText variant="tertiary">{Copyright}</SilkscreenText>
      <SilkscreenText
        as="div"
        variant="tertiary"
        className="flex items-center gap-2"
      >
        <NavLink to={GitBookLink.PrivacyPolicy} target="_blank">
          {t('footer.privacyPolicy')}
        </NavLink>
        <Dividing weight="bold" orientation="vertical" className="h-4" />
        <NavLink to={GitBookLink.TermsOfService} target="_blank">
          {t('footer.termsOfService')}
        </NavLink>
        <Dividing weight="bold" orientation="vertical" className="h-4" />
        <NavLink to={GitBookLink.Fee} target="_blank">
          {t('footer.fees')}
        </NavLink>
      </SilkscreenText>
    </footer>
  )
}

export default Footer
